<template>
  <a-row>
    <a-col :span="12"
      ><a-spin :spinning="state.loading_front">
        <a-upload
          list-type="picture-card"
          accept=".jpeg,.png,.jpg"
          class="avatar-uploader"
          :class="{ 'avatar-uploader-large': props.size === 'large' }"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          @change="
            (info) => {
              handleChange(info, 'id_card_front')
            }
          "
        >
          <a-image
            v-if="state.id_card_front"
            :src="$store.state.user.image_domain + state.id_card_front"
            :preview="{
              visible: false
            }"
            class="upload-img"
          >
            <template #previewMask>
              <EyeOutlined class="mr-1x" style="font-size: 16px" @click.stop="setVisible(true, state.id_card_front)" />
              <DeleteOutlined style="font-size: 16px" />
            </template>
          </a-image>
          <div v-else class="upload-img">
            <PlusOutlined />
            <div class="ant-upload-text">上传人员身份证照片(人像面)</div>
          </div>
        </a-upload>
      </a-spin>
    </a-col>
    <a-col :span="12">
      <a-spin :spinning="state.loading_back">
        <a-upload
          list-type="picture-card"
          class="avatar-uploader"
          :class="{ 'avatar-uploader-large': props.size === 'large' }"
          accept=".jpeg,.png,.jpg"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          @change="
            (info) => {
              handleChange(info, 'id_card_back')
            }
          "
        >
          <a-image
            v-if="state.id_card_back"
            :src="$store.state.user.image_domain + state.id_card_back"
            :preview="{
              visible: false
            }"
            class="upload-img"
          >
            <template #previewMask>
              <EyeOutlined class="mr-1x" style="font-size: 16px" @click.stop="setVisible(true, state.id_card_back)" />
              <DeleteOutlined style="font-size: 16px" />
            </template>
          </a-image>
          <div v-else class="upload-img">
            <PlusOutlined />
            <div class="ant-upload-text">上传人员身份证照片(国徽面)</div>
          </div>
        </a-upload>
      </a-spin>
    </a-col>
  </a-row>
  <image-cropper
    @cancel="
      () => {
        state.showCropper = false
      }
    "
    isId
    :imageUrl="state.imageUrl"
    :imageName="state.imageName"
    :upload_path="props.uploadPath"
    :maxKbSize="1024"
    :isTiqianClose="true"
    @change="cropperPost"
    v-if="state.showCropper"
  ></image-cropper>
  <a-image
    :width="200"
    :style="{ display: 'none' }"
    :preview="{
      visible: state.previewVisible,
      onVisibleChange: setVisible
    }"
    :src="$store.state.user.image_domain + state.previewImage"
  />
</template>
<script lang="ts" setup>
import baseService from '@/utils/http/axios'
import ImageCropper from '@/components/ImageCropper/index.vue'
import cloneDeep from 'lodash.clonedeep'
import { PlusOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { reactive, ref, computed, onMounted, PropType, watch } from 'vue'
import { message } from 'ant-design-vue'
const emit = defineEmits(['update:front', 'update:back', 'change'])
import { nationList } from '@/config/commonValues'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import { stat } from 'fs'
const format = 'YYYY-MM-DD'
const $store = useStore()
const props = defineProps({
  front: {
    type: String,
    default: ''
  },
  back: {
    type: String,
    default: ''
  },
  uploadPath: {
    type: String
  },
  // 尺寸，默认是102*120；large是300*200
  size: {
    type: String,
    default: ''
  }
})
interface state {
  id_card_front: string //身份证人像面
  id_card_back: string //身份证国徽面
  name: string //姓名
  id_card_number: string //身份证号码
  id_card_validity_start: string
  id_card_validity_end: string
  identity_perpetual: string
  address: string
  gender: string
  nationality: string

  loading_front: boolean
  loading_back: boolean
  // 当前上传身份证的字段
  currentUpload: string
  // 进行裁剪的图片地址
  imageUrl: string
  imageName: string
  // 图片裁剪
  showCropper: boolean
  previewImage: string
  previewVisible: boolean
}
const state = reactive<state>({
  id_card_front: '', //身份证人像面
  id_card_back: '', //身份证国徽面
  name: '', //姓名
  id_card_number: '', //身份证号码
  id_card_validity_start: '',
  id_card_validity_end: '',
  identity_perpetual: '',
  address: '',
  gender: '',
  nationality: '',
  loading_front: false,
  loading_back: false,
  // 当前上传身份证的字段
  currentUpload: '',
  // 进行裁剪的图片地址
  imageUrl: '',
  imageName: '',
  // 图片裁剪
  showCropper: false,
  previewImage: '',
  previewVisible: false
})
onMounted(() => {
  state.id_card_front = props.front
  state.id_card_back = props.back
})
watch(
  () => props.front,
  (val) => {
    state.id_card_front = props.front
  }
)
watch(
  () => props.back,
  (val) => {
    state.id_card_back = props.back
  }
)
// 手动上传验证
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('请上传正确图片！')
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('图片必须小于2MB!')
  }
  return false
}
// 图片上传
const handleChange = (info, type) => {
  state.currentUpload = type
  const reader: any = new FileReader()
  //   const isGt1M = info.file.size / 1024 / 1024 > 1
  //   if (isGt1M) {
  //     message.error('图片必须小于1MB!')
  //     return
  //   }
  state.imageName = info.file.name
  reader.readAsDataURL(info.file)
  reader.onload = () => {
    state.imageUrl = reader.result
    state.showCropper = true
  }
}
//上传裁剪后的图片
const cropperPost = (formData, isRecognize) => {
  if (!props.uploadPath) {
    message.error('请先填写主体名称和类型')
    return
  }
  //这个变量会在点另一个的时候变化，先记录一下再关闭窗口
  let currentUpload = state.currentUpload
  state.showCropper = false
  if (currentUpload == 'id_card_front') {
    state.loading_front = true
  } else if (currentUpload == 'id_card_back') {
    state.loading_back = true
  }
  if (isRecognize) {
    let requestParam = {
      url: '/admin/v1/ocr',
      method: 'post',
      data: formData
    }
    baseService(requestParam)
      .then((res) => {
        if (currentUpload == 'id_card_front') {
          state.loading_front = false
        } else if (currentUpload == 'id_card_back') {
          state.loading_back = false
        }
        cropperChange(res, isRecognize, currentUpload)
      })
      .catch((res) => {
        if (res.msg) {
          message.error(res.msg)
        } else {
          message.error('操作失败')
        }
        if (currentUpload == 'id_card_front') {
          state.loading_front = false
        } else if (currentUpload == 'id_card_back') {
          state.loading_back = false
        }
      })
  } else {
    let requestParam = {
      url: '/admin/v1/upload',
      method: 'post',
      data: formData
    }
    baseService(requestParam)
      .then((res) => {
        if (currentUpload == 'id_card_front') {
          state.loading_front = false
        } else if (currentUpload == 'id_card_back') {
          state.loading_back = false
        }
        cropperChange(res.data, isRecognize, currentUpload)
      })
      .catch((res) => {
        if (res.msg) {
          message.error(res.msg)
        } else {
          message.error('操作失败')
        }
        if (currentUpload == 'id_card_front') {
          state.loading_front = false
        } else if (currentUpload == 'id_card_back') {
          state.loading_back = false
        }
      })
  }
}
// 裁剪成功
const cropperChange = (res, isRecognize, currentUpload) => {
  if (isRecognize) {
    let data = res.data.身份证识别实体信息
    if (currentUpload == 'id_card_back') {
      if (data.身份证国徽面实体信息.有效期限.length < 1) {
        message.error('请上传身份证正面照片（国徽面）')
        state.id_card_back = ''
        return
      }
      let list = data.身份证国徽面实体信息.有效期限.split('-').map((item, index) => {
        return item.replaceAll('.', '-')
      })
      let obj = {
        id_card_validity_start: dayjs(list[0], format),
        id_card_validity_end: dayjs(list[1], format),
        identity_perpetual: list[1] == '长期' ? 1 : 2
      }
      Object.assign(state, obj)
    } else if (currentUpload == 'id_card_front') {
      if (data.身份证人像面实体信息.姓名.length < 1) {
        message.error('请上传身份证反面照片（人像面）')
        state.id_card_front = ''
        return
      }
      let nationality: any = null
      nationList.forEach((item) => {
        if (item.indexOf(data.身份证人像面实体信息.民族) > -1) {
          nationality = item
        }
      })
      let obj = {
        name: data.身份证人像面实体信息.姓名,
        address: data.身份证人像面实体信息.住址,
        id_card_number: data.身份证人像面实体信息.身份证号,
        gender: data.身份证人像面实体信息.性别 == '男' ? 1 : 2,
        nationality: nationality
      }
      Object.assign(state, obj)
    }
    state[currentUpload] = res.data.url
  } else {
    state[currentUpload] = res.url
  }
  if (currentUpload == 'id_card_front') {
    emit('update:front', state.id_card_front)
  } else if (currentUpload == 'id_card_back') {
    emit('update:back', state.id_card_back)
  }
  emit('change', {
    id_card_front: state.id_card_front,
    id_card_back: state.id_card_back,
    name: state.name,
    gender: state.gender,
    nationality: state.nationality,
    address: state.address,
    id_card_number: state.id_card_number,
    id_card_validity_start: state.id_card_validity_start,
    id_card_validity_end: state.id_card_validity_end,
    identity_perpetual: state.identity_perpetual
  })
}
//预览
const setVisible = (value, url): void => {
  if (value) {
    state.previewImage = url
    state.previewVisible = true
  } else {
    state.previewVisible = false
  }
}
</script>
<style lang="less" scoped>
.upload-img {
  width: 100% !important;
  height: 100% !important;
}
.avatar-uploader-large {
  :deep(.ant-upload.ant-upload-select-picture-card) {
    width: 300px !important;
    height: 200px !important;
  }
}
</style>
